import { getAutoGeneratedUsername } from 'UserRegistration/resources/api/validation';

export const updatePersonalInformationContextValue = (fieldName, value, registrationData, setRegistrationData) => {
    const updatedRegistrationData = Object.assign({}, registrationData);
    updatedRegistrationData.registrationModel.personalInformation[fieldName] = value;
    setRegistrationData(updatedRegistrationData);
}

export async function populateUsername(value, formikRef, registrationData, setRegistrationData) {
    
    getAutoGeneratedUsername(value, "").then((data) => {
        if (data) {
            formikRef.current.setFieldValue("username", data);
            updatePersonalInformationContextValue("username", data, registrationData, setRegistrationData);
            formikRef.current.validateField("username");
        }
    });

}

export const updateContextValuesOnChange = (event, registrationData, setRegistrationData) => {
    
    const fieldName = event.target.name;
    let value = null;
    
    if (event.target.type === "checkbox") {
        // It's important to check the checked value on the checkbox field instead of the value since the value is set after this onchange event.
        value = event.target.checked;
    } else {
        value = event.target.value;
    }

    updatePersonalInformationContextValue(fieldName, value, registrationData, setRegistrationData);
    
}